import { AuthContext } from 'context/authContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { ErrorToast } from 'services/toasterService';

export default function useUpdateCompanyDetails() {
  const { authDispatch } = useContext(AuthContext);

  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.put(
        apiEndPoints.COMPANY_DETAILS,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        authDispatch({
          type: 'UPDATECOMPANYLOGO',
          payload: data?.data?.company_logo,
        });
        queryClient.invalidateQueries('get-company-details');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
